module.exports = __webpack_public_path__ + "assets/img/Telegram_icon.e1f84c7f.jpg";